const styles = theme => ({
    root: {
        backgroundColor: "transparent",
    },
    gutters:{
        paddingRight:"0px",
        paddingLeft:"0px",
    },
    grow: {
        flexGrow: 1,
        textAlign:"center"
    },
    wrongEnvironmentWarning:{
        fontSize:"12px",
        color:theme.ErrorMessageColor,
        fontWeight:"bold",
        [theme.breakpoints.down('md')]: {
            fontSize:"10px"
        },
        [theme.breakpoints.down('sm')]: {
            fontSize:"8px",
        },
    },
    hideWarning:{
        display:"none"
    },
    prodLink:{
        color:theme.HeaderSelectedText,
        textDecoration:"underline",
        '&:hover':{
            opacity:"0.7",
            cursor:"pointer",
        }
    },
    tabsRoot: {
        marginLeft: "20px",
        [theme.breakpoints.down('md')]: {
            marginLeft: "5px",
        }
    },
    headerStyles: {
        backgroundColor: theme.HeaderBGColor,
        height: "46px"
    },
    tabRoot: {
        textTransform: "initial",
        fontSize: "14px",
        color: theme.HeaderDefaultTextColor,
        fontWeight: "600",
        "&$tabSelected": {
            color: theme.HeaderSelectedText,

        },
        '&:hover': {
            color: theme.HeaderSelectedText,
            opacity: 1,
        },
        [theme.breakpoints.down('md')]: {
            fontSize:"12px"
        },
        [theme.breakpoints.down('sm')]: {
            fontSize:"9px"
        }
    },
    tabsIndicator: {
        backgroundColor: theme.HeaderSelectedText,
        height: "4px"
    },
    tabSelected: {},
    headerIcons: {
        height: "100%",
        padding: "6px 0",
        boxSizing: "border-box",
        color: theme.headerIconColor,
        '& div': {
            float: "left"
        },
    },
    headerIconStyles: {
        height: "32px",
        boxSizing: "border-box",
        cursor: "pointer",
        '&:hover': {
            color: theme.HeaderSelectedText,
        },
    },
    refreshContainer: {
        padding:"0 16px",
        [theme.breakpoints.down('md')]: {
            padding:"0px"
        }
    },
    refreshIconContainer:{
        paddingTop: "7px",
    },
    refreshIcon: {
        float: "left",
        cursor: "pointer",
        '&:hover': {
            color: theme.HeaderSelectedText
        },
    },
    refreshText: {
        float: "left",
        fontSize: "9px",
        fontWeight: "600",
        display: "flex",
        flexDirection: "column",
        lineHeight: "13px",
        paddingRight: "8px",
        height: "100%",
        cursor : "pointer"
    },
    planDate:{
        fontSize:theme.textFontSize,
        color:"white",
        letterSpacing:"0.05em",
        [theme.breakpoints.down('md')]: {
            fontSize:"9px"
        },
    },
    scenarioDetail:{
        lineHeight: "24px"
    },
    optymizeBtnContainer: {
        borderLeft: `1px solid ${theme.headerBorderColor}`,
        padding: "0px 15px",
        [theme.breakpoints.down('md')]: {
            border:"0px"
        }
    },
    optymizeButtonStyle: {
        padding: "4px 6px",
        width: "125px",
        fontWeight: "bold",
        height: "32px",
		borderRadius: "2px",
		'&$disabledOptymizeBtn':{
			 color: "white",
			 fontWeight: "bold",
			 height: "32px",
			 borderRadius: "2px",
			 opacity: "0.4",
			 cursor: "not-allowed",
			//  pointerEvents: "auto",
			 background: theme.HeaderSelectedText,
			 '&:hover':{
				 background: theme.HeaderSelectedText,
				 opacity: "0.4"
			 }
		 },
    },
    disabledOptymizeBtn:{},
    terminalIconStyle: {
        borderLeft: `1px solid ${theme.headerBorderColor}`,
        padding: "9px 0px 9px 5px",
        fontSize: "14px",
        fontWeight:"bold",
        color:theme.HeaderSelectedText,
        width:"72px",
        textAlign:"center",
        '&:hover': {
            opacity: "0.7"
        },
    },
    publishIconContainer: {
        borderLeft: `1px solid ${theme.headerBorderColor}`,
        padding: "5px 15px"
    },
    publishIconStyle: {
        border: `1px solid ${theme.HeaderSelectedText}`,
        padding: "2px",
        borderRadius: "2px",
        color: theme.HeaderSelectedText,
        '&:hover': {
            opacity: "0.7"
        },
    },
    disabledPublishIcon: {
        border: `1px solid ${theme.HeaderSelectedText}`,
        padding: "2px",
        borderRadius: "2px",
        color: theme.HeaderSelectedText,
        cursor:"not-allowed",
        opacity: "0.5"
    },
    muiIconContainer: {
        borderLeft: `1px solid ${theme.headerBorderColor}`,
    },
    muiIconButtonStyle: {
        padding: "9px 15px"
    },
    paper: {
        background: theme.ModalBGColor,
        borderRadius: "0px 0px 4px 4px",
        width: "291px",
        padding: "2px",
        marginTop: "10px",
        overflow: "visible"
    },
    placementRight: {
        maxWidth: "199px",
    },
    starIconColor:{
        color:theme.starIconColor,
    },
    disableHelpMenuHover:{
        '&:hover':{
            background:theme.ModalBGColor,
        }
    },
    helpMenu:{
        background: theme.ModalBGColor,
        borderRadius: "0px 0px 4px 4px",
        marginTop: "8px",
        overflow: "visible",
    },
    helpMenuItem:{
        fontSize:"12px",
        lineHeight:"14px",
        color:theme.TextColor,
        padding:"4px 18px 4px 4px",
    },
    moduleSwitcher:{
        fontSize:"17px",
        color:theme.HeaderDefaultTextColor,
        [theme.breakpoints.down('md')]: {
            fontSize:"14px"
        },
        [theme.breakpoints.down('sm')]: {
            fontSize:"11px"
        }
    },
    toggledMenu:{
        display:"none",
        [theme.breakpoints.down('md')]: {
            display:"block"
        }
    },
    mainMenu:{
        background: theme.HeaderBGColor,
        borderRadius: "0px 0px 4px 4px",
        marginTop: "30px",
        overflow: "visible"
    },
    mainMenuStyle:{
        display:"block",
        padding:"12px 0px",
        width:"364px"
    },
    rmaxLogo:{
        height: "15px",
        [theme.breakpoints.down('md')]: {
            width:"90px"
        }
    },
    shipmentSelectionRmaxLogo : {
        height: "15px",
        padding:"12px",
        [theme.breakpoints.down('md')]: {
            width:"90px"
        }
    },
    mainMenuButton:{
        padding:"9px",
        color:theme.HeaderSelectedText
	},
	disabledCursor:{
		cursor:"not-allowed"
	},
});

export default styles;